(function () {
  const widgets = document.querySelectorAll("[data-br-review-proof]");
  if (!widgets.length) return;

  const escapeHtml = (value) =>
    String(value == null ? "" : value).replace(/[&<>"']/g, (char) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;"
    })[char]);

  const stars = (rating) => {
    const rounded = Math.round(Number(rating || 0));
    return "★★★★★".slice(0, rounded) + "☆☆☆☆☆".slice(0, 5 - rounded);
  };

  const fetchJson = async (baseUrl, path, params) => {
    const response = await fetch(`${baseUrl}${path}?${params.toString()}`, { credentials: "omit" });
    if (!response.ok) throw new Error(`Review proof request failed: ${response.status}`);
    return response.json();
  };

  const paramsFor = (widget, limit) => {
    const params = new URLSearchParams({
      shop: widget.dataset.shop || "",
      limit: String(limit || 5)
    });
    if (widget.dataset.productId) params.set("product_id", widget.dataset.productId);
    if (widget.dataset.handle) params.set("handle", widget.dataset.handle);
    return params;
  };

  const fiveStarParamsFor = (widget) => {
    const params = paramsFor(widget, 1);
    params.set("rating", "5");
    return params;
  };

  const imageHtml = (image) => `
    <span class="br-review-proof__image">
      <img src="${escapeHtml(image.image_url)}" alt="${escapeHtml(image.alt_text || "")}" loading="lazy">
    </span>
  `;

  const reviewQuoteHtml = (review) => {
    if (!review || !review.body) return "";
    const quote = String(review.body).trim();
    const shortened = quote.length > 118 ? `${quote.slice(0, 115).trim()}...` : quote;
    return `
      <div class="br-review-proof__quote">
        <p>"${escapeHtml(shortened)}"</p>
        <span>${escapeHtml(review.reviewer_name || "Verified customer")}</span>
      </div>
    `;
  };

  const render = async (widget) => {
    if (widget.dataset.rendered === "true") return;
    widget.dataset.rendered = "true";

    const baseUrl = (widget.dataset.apiBase || "").replace(/\/$/, "");
    if (!baseUrl || !widget.dataset.shop) return;

    const imageLimit = Number(widget.dataset.imageLimit || 5);
    const [summary, ugc, reviewsData] = await Promise.all([
      fetchJson(baseUrl, "/api/storefront/summary", paramsFor(widget, 1)),
      widget.dataset.showImages === "true"
        ? fetchJson(baseUrl, "/api/storefront/ugc", paramsFor(widget, imageLimit))
        : Promise.resolve({ images: [] }),
      fetchJson(baseUrl, "/api/storefront/reviews", fiveStarParamsFor(widget))
    ]);

    const reviewCount = Number(summary.review_count || 0);
    const rating = Number(summary.rating_value || 0);
    if (!reviewCount || !rating) return;

    const images = (ugc.images || []).slice(0, imageLimit);
    const review = (reviewsData.reviews || [])[0];
    const countText = `${reviewCount} ${reviewCount === 1 ? "review" : "reviews"}`;
    const productTitle = widget.dataset.productTitle || "this product";
    const proofText = widget.dataset.proofText || "Loved by customers";

    widget.innerHTML = `
      <div class="br-review-proof__header">
        <div class="br-review-proof__copy">
          <span>${escapeHtml(proofText)}</span>
          <small>Real customer feedback on ${escapeHtml(productTitle)}</small>
        </div>
        <div class="br-review-proof__rating" aria-label="${escapeHtml(rating.toFixed(1))} out of 5 based on ${escapeHtml(countText)}">
          <span class="br-review-proof__stars" aria-hidden="true">${stars(rating)}</span>
          <strong>${rating.toFixed(1)}</strong>
          <small>${escapeHtml(countText)}</small>
        </div>
      </div>
      ${images.length ? `<div class="br-review-proof__images">${images.map(imageHtml).join("")}</div>` : ""}
      ${reviewQuoteHtml(review)}
    `;
    widget.hidden = false;
  };

  widgets.forEach((widget) => {
    render(widget).catch(() => {
      widget.hidden = true;
    });
  });
})();
